<template>
	<div class="follow" v-if="isShow">
		<div class="el-dialog__header flex-just-between flex">
			<span>提示</span>
			<i class="el-icon-close close" @click="confirm"></i>
		</div>
		<div class="el-dialog__body">
			<div v-if="isFollow == '0'">
				<p class="fz-14 yx-color-text-primary">无法接受微信通知！</p>
				<div class="publicInfo flex mt-16">
					<div class="public-img">
						<img :src="wxUrl" alt="" />
					</div>
					<div class="ml-14 flex-1">
						<div class="flex flex-align-center">
							<yx-avatar :size="44" :src="wx_info.avatar_url"></yx-avatar>
							<p class="ml-12 yx-color-text-primary fz-14">
								{{ wx_info.nick_name }}
							</p>
						</div>
						<div class="info yx-color-text-regular fz-13 mt-8">
							<p>请用以上微信号进行扫码关注公众号</p>
							<p>关注后可接受查看商品、申样、开播等消息通知</p>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<p class="yx-color-text-primary fz-14 font-bold">微信通知已开启！</p>
				<p class="yx-color-text-primary fz-14 mt-10"> 我们将通过微信公众号向您发送达人招商查看商品、选品、申样、开播等关键信息提醒 </p>
			</div>
		</div>
		<div class="el-dialog__footer">
			<div class="dialog-footer">
				<el-button type="primary" @click="confirm">我知道了</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { checkFollow } from '@/api/common';
import mixin from '@/mixins';
export default {
	mixins: [mixin],
	name: 'sendGood',
	components: {
		
	},
	data() {
		return {
			isShow: false,
			isFollow: 10,
			wx_info: {},
			timer: '',
			timeout: '',
			wxUrl: '',
		};
	},
	created() {
		this.initCheck(1);
	},
	watch: {
		isFollow: {
			handler(to, from) {
				if (to == '0') {
					this.timer = setInterval(() => {
						this.initCheck();
					}, 60000);
				} else if (to == '1') {
					clearInterval(this.timer);
					this.timeout = setTimeout(() => {
						this.isShow = false;
					}, 5000);
				}
			},
			immediate: true,
		},
	},
	beforeDestroy() {
		clearTimeout(this.timeout);
		clearInterval(this.timer);
	},
	methods: {
		async initCheck(state) {
			const { code, data } = await checkFollow({});
			if (code == 0) {
				this.isFollow = data.is_follow;
				if (this.isFollow == '0') {
					this.isShow = true;
				} else {
					if (state) {
						this.isShow = false;
					}
				}
				this.wx_info = data.wx_info;
				this.wxUrl = data.wx_url;
			}
		},
		confirm() {
			this.isShow = false;
			clearInterval(this.timer);
		},
	},
};
</script>
<style lang="less" scoped>
.follow {
	width: 400px;
	background-color: #fff;
	z-index: 2000;
	border: 1px solid #f8f8f8;
	// box-shadow: darkgrey 0px 0px 30px 5px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	.el-dialog__header {
		padding: 16px;
		align-items: center;
		font-weight: 500;
	}
	.el-dialog__body {
		padding: 12px 16px 16px !important;
	}
	.el-dialog__footer {
		padding: 0 16px 16px;
	}
}

.public-img img {
	width: 110px;
	height: 110px;
}
.publicInfo {
	padding: 16px;
	background-color: rgba(36, 117, 255, 0.04);
	border-radius: 4px;
}
.close {
	cursor: pointer;
}
.info {
	line-height: 22px;
}
</style>
